module.exports = __webpack_public_path__ + "img/2607f752514558aaafc941724c87e76.6f490fe9.jpg";